//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scrollTo from 'libs/scrollTo'
import ColumnedexpandableBlock from 'components/blocks/ColumnedExpandable.vue'
import Link from 'components/mixins/Link.vue'

export default {
  name: "ColumnedExpandablelist",
  block: 'columnedExpandableList',
  props: ['data','sharedData'],
  components: {
    ColumnedexpandableBlock,
  },
  mixins: [
    Link,
  ],
  data() {
    return {
      scrolled: false
    }
  },
  methods: {
    toggleQuestion(index) {
      this.data.active = index;
    },
  },
  computed: {
    icon() {
      return (this.data.icon || '24px_chevronDown');
    },
  },
  watch: {
    'sharedData.scrollingPosition': function(index) {
      const anchors = this.$el.querySelectorAll('[anchor]');
      const offsetTop = anchors[index].offsetTop;

      scrollTo(document.body, offsetTop, 500);
    }
  },
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/ColumnedExpandablelist.vue